export const LANGS = [
  { code: "en", label: "English", flag: "EN" },
  { code: "tr", label: "Türkçe", flag: "TR" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "pt", label: "Português", flag: "PT" },
];

const T = {
  en: {
    tagline: "Find your next address.",
    sub: "Ask in plain language. Aegis, your AI real estate advisor, will guide you.",
    placeholder: "e.g. A 2-bed apartment in Lisbon under €500k",
    ask: "Ask",
    thinking: "Aegis is thinking",
    forAgents: "For sellers",
    newlyAdded: "Newly added",
    mortgageTitle: "Mortgage calculator",
    mortgageLoan: "Loan amount",
    mortgageRate: "Annual interest rate (%)",
    mortgageTerm: "Term (years)",
    mortgageCalc: "Calculate",
    mortgageMonthly: "Monthly payment",
    mortgageNote: "Check the current rate with your bank.",
    whyTitle: "Why Arealtor?",
    why1Title: "24/7 AI Advisor",
    why1Text: "Your clients get instant answers, even at midnight.",
    why2Title: "Save Time",
    why2Text: "Let AI handle repetitive questions so you focus on real clients.",
    why3Title: "Quick Setup",
    why3Text: "Add your listings and go live in 10 minutes.",
    listings: "Matches",
    login: "Log in",
    register: "Get started",
    signOut: "Sign out",
    dashboard: "Dashboard",
    billing: "Billing",
    myListings: "My listings",
    addListing: "Add listing",
    trial: "Free trial",
    daysLeft: "days left",
    email: "Email",
    password: "Password",
    name: "Full name",
    agency: "Agency (optional)",
    or: "or",
    google: "Continue with Google",
    already: "Already have an account?",
    noAccount: "Don't have an account?",
    signIn: "Sign in",
    createAccount: "Create account",
  },
  tr: {
    tagline: "Yeni adresinizi bulun.",
    sub: "Sıradan bir cümleyle sorun. Yapay zeka emlak danışmanı Aegis size rehberlik eder.",
    placeholder: "örn. Lizbon'da 500.000 € altı 2+1 daire",
    ask: "Sor",
    thinking: "Aegis düşünüyor",
    forAgents: "Satıcılar için",
    newlyAdded: "Yeni eklenenler",
    mortgageTitle: "Konut kredisi hesaplayıcı",
    mortgageLoan: "Kredi tutarı",
    mortgageRate: "Yıllık faiz oranı (%)",
    mortgageTerm: "Vade (yıl)",
    mortgageCalc: "Hesapla",
    mortgageMonthly: "Aylık ödeme",
    mortgageNote: "Güncel faiz oranını bankanızdan öğrenin.",
    whyTitle: "Neden Arealtor?",
    why1Title: "7/24 Yapay Zeka Danışmanı",
    why1Text: "Müşterileriniz gece yarısı bile sorularına anında cevap alır.",
    why2Title: "Zaman Kazanın",
    why2Text: "Tekrar eden soruları yapay zeka yanıtlar, siz sadece gerçek müşterilere odaklanırsınız.",
    why3Title: "Hızlı Kurulum",
    why3Text: "10 dakikada ilanlarınızı ekleyin, sistemi çalıştırın.",
    listings: "Sonuçlar",
    login: "Giriş",
    register: "Başla",
    signOut: "Çıkış",
    dashboard: "Panel",
    billing: "Fatura",
    myListings: "İlanlarım",
    addListing: "İlan ekle",
    trial: "Ücretsiz deneme",
    daysLeft: "gün kaldı",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    agency: "Ofis (opsiyonel)",
    or: "veya",
    google: "Google ile devam et",
    already: "Hesabınız var mı?",
    noAccount: "Hesabınız yok mu?",
    signIn: "Giriş yap",
    createAccount: "Hesap oluştur",
  },
  de: {
    tagline: "Finde deine nächste Adresse.",
    sub: "Frag einfach. Aegis, dein KI-Immobilienberater, führt dich.",
    placeholder: "z. B. 2-Zimmer-Wohnung in Berlin unter 400.000 €",
    ask: "Fragen",
    thinking: "Aegis denkt nach",
    forAgents: "Für Verkäufer",
    mortgageTitle: "Hypothekenrechner",
    mortgageLoan: "Kreditbetrag",
    mortgageRate: "Jährlicher Zinssatz (%)",
    mortgageTerm: "Laufzeit (Jahre)",
    mortgageCalc: "Berechnen",
    mortgageMonthly: "Monatliche Rate",
    mortgageNote: "Erfragen Sie den aktuellen Zinssatz bei Ihrer Bank.",
    listings: "Treffer",
    login: "Anmelden",
    register: "Loslegen",
    signOut: "Abmelden",
    dashboard: "Dashboard",
    billing: "Abrechnung",
    myListings: "Meine Angebote",
    addListing: "Angebot hinzufügen",
    trial: "Testphase",
    daysLeft: "Tage übrig",
    email: "E-Mail",
    password: "Passwort",
    name: "Vollständiger Name",
    agency: "Agentur (optional)",
    or: "oder",
    google: "Mit Google fortfahren",
    already: "Schon ein Konto?",
    noAccount: "Noch kein Konto?",
    signIn: "Anmelden",
    createAccount: "Konto erstellen",
  },
  fr: {
    tagline: "Trouvez votre prochaine adresse.",
    sub: "Demandez simplement. Aegis, votre conseiller immobilier IA, vous guide.",
    placeholder: "ex. Appartement 2 pièces à Paris sous 700 000 €",
    ask: "Demander",
    thinking: "Aegis réfléchit",
    forAgents: "Pour les vendeurs",
    mortgageTitle: "Calculateur d'hypothèque",
    mortgageLoan: "Montant du prêt",
    mortgageRate: "Taux d'intérêt annuel (%)",
    mortgageTerm: "Durée (années)",
    mortgageCalc: "Calculer",
    mortgageMonthly: "Mensualité",
    mortgageNote: "Renseignez-vous auprès de votre banque pour le taux actuel.",
    listings: "Résultats",
    login: "Connexion",
    register: "Commencer",
    signOut: "Déconnexion",
    dashboard: "Tableau",
    billing: "Facturation",
    myListings: "Mes annonces",
    addListing: "Ajouter",
    trial: "Essai gratuit",
    daysLeft: "jours restants",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom complet",
    agency: "Agence (optionnel)",
    or: "ou",
    google: "Continuer avec Google",
    already: "Déjà un compte ?",
    noAccount: "Pas de compte ?",
    signIn: "Se connecter",
    createAccount: "Créer un compte",
  },
  es: { tagline: "Encuentra tu próxima dirección.", sub: "Pregunta en lenguaje natural.", placeholder: "p. ej. Piso de 2 dormitorios en Madrid bajo 500.000 €", ask: "Preguntar", thinking: "Aegis está pensando", forAgents: "Para vendedores", listings: "Resultados", login: "Entrar", register: "Empezar", signOut: "Salir", dashboard: "Panel", billing: "Facturación", myListings: "Mis anuncios", addListing: "Añadir", trial: "Prueba gratis", daysLeft: "días restantes", email: "Correo", password: "Contraseña", name: "Nombre", agency: "Agencia (opcional)", or: "o", google: "Continuar con Google", already: "¿Ya tienes cuenta?", noAccount: "¿Sin cuenta?", signIn: "Entrar", createAccount: "Crear cuenta" },
  it: { tagline: "Trova il tuo prossimo indirizzo.", sub: "Chiedi in linguaggio naturale.", placeholder: "es. Bilocale a Milano sotto 500.000 €", ask: "Chiedi", thinking: "Aegis sta pensando", forAgents: "Per venditori", listings: "Risultati", login: "Accedi", register: "Inizia", signOut: "Esci", dashboard: "Cruscotto", billing: "Fatturazione", myListings: "I miei annunci", addListing: "Aggiungi", trial: "Prova gratuita", daysLeft: "giorni rimasti", email: "Email", password: "Password", name: "Nome", agency: "Agenzia (opzionale)", or: "o", google: "Continua con Google", already: "Hai già un account?", noAccount: "Non hai un account?", signIn: "Accedi", createAccount: "Crea account" },
  nl: { tagline: "Vind je volgende adres.", sub: "Vraag in natuurlijke taal.", placeholder: "bv. 2-kamerappartement Amsterdam onder €500k", ask: "Vraag", thinking: "Aegis denkt na", forAgents: "Voor verkopers", newlyAdded: "Nieuw toegevoegd", whyTitle: "Waarom Arealtor?", why1Title: "24/7 AI Adviseur", why1Text: "Uw klanten krijgen direct antwoord, ook 's nachts.", why2Title: "Bespaar Tijd", why2Text: "Laat AI herhaalde vragen afhandelen, zodat u zich richt op echte klanten.", why3Title: "Snelle Installatie", why3Text: "Voeg uw woningen toe en ga live in 10 minuten.", mortgageTitle: "Hypotheekcalculator", mortgageLoan: "Leenbedrag", mortgageRate: "Jaarlijkse rente (%)", mortgageTerm: "Looptijd (jaren)", mortgageCalc: "Bereken", mortgageMonthly: "Maandelijkse betaling", mortgageNote: "Controleer de actuele rente bij uw bank.", listings: "Resultaten", login: "Inloggen", register: "Beginnen", signOut: "Uitloggen", dashboard: "Dashboard", billing: "Facturatie", myListings: "Mijn advertenties", addListing: "Toevoegen", trial: "Gratis proefperiode", daysLeft: "dagen over", email: "E-mail", password: "Wachtwoord", name: "Naam", agency: "Kantoor (optioneel)", or: "of", google: "Doorgaan met Google", already: "Al een account?", noAccount: "Geen account?", signIn: "Inloggen", createAccount: "Account maken" },
  pl: { tagline: "Znajdź swój następny adres.", sub: "Zapytaj naturalnym językiem.", placeholder: "np. Mieszkanie 2-pokojowe w Warszawie do 400 000 zł", ask: "Zapytaj", thinking: "Aegis myśli", forAgents: "Dla sprzedawców", newlyAdded: "Ostatnio dodane", whyTitle: "Dlaczego Arealtor?", why1Title: "Doradca AI 24/7", why1Text: "Twoi klienci otrzymują natychmiastowe odpowiedzi, nawet w nocy.", why2Title: "Oszczędź Czas", why2Text: "Pozwól AI obsługiwać powtarzające się pytania i skup się na prawdziwych klientach.", why3Title: "Szybka Konfiguracja", why3Text: "Dodaj ogłoszenia i uruchom system w 10 minut.", mortgageTitle: "Kalkulator kredytu hipotecznego", mortgageLoan: "Kwota kredytu", mortgageRate: "Roczne oprocentowanie (%)", mortgageTerm: "Okres (lata)", mortgageCalc: "Oblicz", mortgageMonthly: "Rata miesięczna", mortgageNote: "Sprawdź aktualne oprocentowanie w swoim banku.", listings: "Wyniki", login: "Zaloguj", register: "Zacznij", signOut: "Wyloguj", dashboard: "Panel", billing: "Płatności", myListings: "Moje ogłoszenia", addListing: "Dodaj", trial: "Okres próbny", daysLeft: "dni pozostało", email: "E-mail", password: "Hasło", name: "Imię i nazwisko", agency: "Agencja (opcjonalnie)", or: "lub", google: "Kontynuuj z Google", already: "Masz już konto?", noAccount: "Nie masz konta?", signIn: "Zaloguj się", createAccount: "Utwórz konto" },
  pt: { tagline: "Encontre o seu próximo endereço.", sub: "Pergunte em linguagem natural.", placeholder: "ex. T2 em Lisboa abaixo de 500.000 €", ask: "Perguntar", thinking: "Aegis está a pensar", forAgents: "Para vendedores", listings: "Resultados", login: "Entrar", register: "Começar", signOut: "Sair", dashboard: "Painel", billing: "Faturação", myListings: "Meus anúncios", addListing: "Adicionar", trial: "Período gratuito", daysLeft: "dias restantes", email: "Email", password: "Palavra-passe", name: "Nome", agency: "Agência (opcional)", or: "ou", google: "Continuar com Google", already: "Já tem conta?", noAccount: "Sem conta?", signIn: "Entrar", createAccount: "Criar conta" },
};

export function t(lang, key) {
  return (T[lang] && T[lang][key]) || T.en[key] || key;
}
